export const monthLabels = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const renderThumb = ({ style, ...props }) => <div style={{ ...style, backgroundColor: `rgba(0,0,0,0.2)` }} {...props}/>;

export const pad = (n, width, z = '0') => {
    return String(n).padStart(width, z);
}
